module.exports = __webpack_public_path__ + "static/media/16UNODC30.71555865.jpg";